import { useRef } from 'react';
import constate from 'constate';
import Player from 'react-player/file';
const SRC = 'finalcut.provider.ts';

import { getInternalPlayer } from 'components/app/_helpers/_app.helper';

export type TrackRoot = HTMLDivElement;
export type TrackFeed = HTMLDivElement;

const useFinalcutProvider = () => {
  const fcPlayerRef = useRef<Player | null>(null);
  const fcPlayerReady = useRef(false);

  const fcPlayerSeekTo = (value: SeekToValue, type: SeekToType) => {
    if (!fcPlayerRef.current) {
      console.error(`[${SRC}] fcSeekTo`);
      return;
    }
    fcPlayerRef.current.seekTo(value, type);
  };

  const fcPlayerPlay = (value: boolean) => {
    const player = getInternalPlayer(fcPlayerRef.current);
    if (!player) {
      console.error(`[${SRC}] fcPlayerPlay`);
      return;
    }
    if (value) player.play();
    else player.pause();
  };

  const fcPlayerGetDuration = () => {
    if (!fcPlayerRef.current) {
      console.error(`[${SRC}] fcPlayerGetDuration`);
      return 0;
    }
    return fcPlayerRef.current.getDuration();
  };

  return { fcPlayerRef, fcPlayerReady, fcPlayerPlay, fcPlayerSeekTo, fcPlayerGetDuration };
};

export const [FinalcutProvider, useFinalcutContext] = constate(useFinalcutProvider);
